'use strict';

$(document).ready(function () {
    require('./sentry/main').init();
});
